"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceName = void 0;
var ServiceName;
(function (ServiceName) {
    ServiceName["URITHIRU"] = "URITHIRU";
    ServiceName["UNKNOWN"] = "UNKNOWN";
})(ServiceName = exports.ServiceName || (exports.ServiceName = {}));
